// What's wrong with a value in a form, found before it's sent (src/components/format.ts). The API's own answers are in
// errors.ts.
export const validation = {
    usernameRequired: 'Enter a username.',
    usernameCharacters: 'Use only letters (A–Z), digits, dashes (-) and underscores (_), with no spaces.',
    emailInvalid: 'Enter a valid email address.',
    emailPlusAddressed: "Addresses with '+' aren't supported.",
    passwordTooShort: 'Use at least {min} characters.',
    passwordsDontMatch: "The passwords don't match.",
    // Help under a new password field, and its error.
    passwordHelp: 'At least {min} characters.',
    passwordShort: 'Too short.'
};

export type ValidationMessages = typeof validation;
